import apirecebimentoweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const { data } = await apirecebimentoweb.get('contratomp/resumo', { params: { ...where, ...params } });
      return { data };
    },

    async findSafras() {
      const { data } = await apirecebimentoweb.get('contratomp/safras');
      return data;
    },

    async findResumoFisica(_, { nrocontrato, safra } = {}) {
      const { data } = await apirecebimentoweb.get(`contratomp/resumo/fisica/${nrocontrato}/${safra}`);
      return data;
    },

    async findResumoFinanceiro(_, { nrocontrato, safra } = {}) {
      const { data } = await apirecebimentoweb.get(`contratomp/resumo/financeiro/${nrocontrato}/${safra}`);
      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
